import { useNavigate } from "react-router-dom";
import { BaseButton } from "../../../components/button/styled";
import { H1, P } from "../../../components/typography/styled";
import { HeroImage } from "../../../assets";
import {
  HeroButtonRow,
  HeroWrapper,
  HeroContainer,
  HeroTextContent,
  HeroImagePlaceholder,
} from "./styled";

export const Hero = () => {
  const navigate = useNavigate();

  const handleNavigation = (e, destination) => {
    e.preventDefault();
    e.stopPropagation();
    return navigate(destination);
  };

  return (
    <HeroWrapper>
      <HeroContainer>
        <HeroTextContent>
          <H1>Revolutionize Payroll Management With workPlacePAY</H1>
          <P>
            Welcome to workPlacePAY, where managing payroll is no longer a
            chore. Our Payroll Management System is your key to streamlined,
            error-free payroll processing. Set it up once, and experience the
            ease of payroll management forever.
          </P>
          <HeroButtonRow>
            <BaseButton
              width={"fit-content"}
              onClick={(e) => handleNavigation(e, "/how")}
            >
              Get Started
            </BaseButton>
          </HeroButtonRow>
        </HeroTextContent>
        <HeroImagePlaceholder>
          <img src={HeroImage} alt="Hero" />
        </HeroImagePlaceholder>
      </HeroContainer>
    </HeroWrapper>
  );
};
